// extracted by mini-css-extract-plugin
export default {"wrapper":"OfferSourceCell_wrapper__NM6dY","sourceType":"OfferSourceCell_sourceType__bm6y2","sourceName":"OfferSourceCell_sourceName__szvg1"};